//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import axios from 'axios'
import EventBus from '~/eventBus'

import me from '~/data/me'
import history from '~/data/history'

import { scroll } from 'quasar'
const { getScrollTarget, setScrollPosition } = scroll

export default {
    layout: 'default',
    middleware: [],

    data(){ return {
        ...me,
        history,
        thisYear: moment().format('YYYY'),
        colors: [
            'bg-pink-9', 'bg-pink-5', 'bg-pink-10', 'bg-pink-13', 'bg-pink-7',
            'bg-red-9', 'bg-red-5', 'bg-red-10', 'bg-red-13', 'bg-red-7',
            'bg-light-blue-9', 'bg-light-blue-5', 'bg-light-blue-10', 'bg-light-blue-13', 'bg-light-blue-7',
            'bg-teal-9', 'bg-teal-5', 'bg-teal-10', 'bg-teal-13', 'bg-teal-7',
            'bg-purple-9', 'bg-purple-5', 'bg-purple-10', 'bg-purple-13', 'bg-purple-7',
            'bg-amber-9', 'bg-amber-5', 'bg-amber-10', 'bg-amber-13', 'bg-amber-7',
            'bg-light-green-9', 'bg-light-green-5', 'bg-light-green-10', 'bg-light-green-13', 'bg-light-green-7',
        ]
    }},

    metaInfo(){ return {
        title: 'Welcome to Gkiokan.NET',
        link: [
            { rel: 'canonical', href: window.location.origin }
        ],
        meta: this.$rm.getMeta(this), // this.$route.meta,
        script: [
            {
                type: 'application/ld+json',
                json: {
                    "@context" : "http://schema.org",
                    "@type": "Person",
                    "@id": "https://gkiokan.net",
                    "url": "https://gkiokan.net",
                    "name": "Gkiokan Sali",
                    "email": "me@gkiokan.net",
                    "image": "https://gkiokan.net/modules/web/img/g_2018.jpeg",
                    "jobTitle": "Owner of Gkiokan.NET & Fullstack Developer"
                }
            }
        ]
    }},

    filters: {
        getDate(val){
            return moment(val).format('DD.MM.YYYY')
        }
    },

    computed: {
        user(){ return this.$store.getters['auth/user'] },
        token(){ return this.$store.getters['auth/token'] },
    },

    mounted(){
        // console.log(this)
        EventBus.$on('intro.next.clicked', () => this.$scrollTo('#projects'))
    },

    methods: {
        mailto(){
            location.href = 'mailto:me@gkiokan.net?subject=Contact%20from%20your%20Website'
        },

        login(){
            let href = window.location.href
            let auth = this.$root.config.api.login
            let go = auth + '?cb=' + href

            window.location = go
        },

        register(){
            let href = window.location.href
            let auth = this.$root.config.api.register
            let go = auth + '?cb=' + href

            window.location = go
        },
        
    }
}
